import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

import * as ar from '../assets/i18n/ar.json';
import * as en from '../assets/i18n/en.json';

const translations: { [lang: string]: object } = {
  ar: (ar as any).default || ar,
  en: (en as any).default || en
};

export class BundledTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<object> {
    return of(translations[lang] || translations['ar']);
  }
}

export function bundledTranslateLoader(): BundledTranslateLoader {
  return new BundledTranslateLoader();
}
